// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__3kurR","layout__main":"Layout_layout__main__lgial"};